import { render, staticRenderFns } from "./MonacoDiffEditor.vue?vue&type=template&id=7de8c46c"
import script from "./MonacoDiffEditor.vue?vue&type=script&lang=js"
export * from "./MonacoDiffEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports